/**
 * This module is created so that, only a single configuration has to
 * maintained to requirejs, grunt and r.js optimiser
 */
(function() {
    'use strict';
    /**
     * a hack function to export requirejs configuration to window or to some
     * importing node module. It also provides the hack to fool rjs to load
     * requirejs configuration
     * @param  {Object} requireConfig configuration for requirejs
     * @return {undefined}
     */
    var requirejs = function(requireConfig) {
        //  check if executing on grunt
        if (typeof module !== 'undefined') {
            module.exports = requireConfig;
        } else if (typeof window !== 'undefined') {
            window.requireConfig = requireConfig;
        }
    };
    /**
     * Actual requirejs configuration
     * @type {Object}
     */
    requirejs({
        waitSeconds: 200,
        paths: {
            'text': '../../vendors/requirejs-text/text',
            'durandal': '../../vendors/Durandal/js',
            'plugins': '../../vendors/Durandal/js/plugins',
            'transitions': '../../vendors/Durandal/js/transitions',
            'knockout': '../../vendors/knockout/build/output/knockout-latest',
            'bootstrap': '../../vendors/bootstrap/dist/js/bootstrap.min',
            'jquery': '../../vendors/jquery/jquery.min',
            'jqueryUi': '../../vendors/jquery-ui/jquery-ui.min',
            'kendo': '../../vendors/kendo-ui-web/src/dist/js/kendo.web.min',
            'highstock': '../../vendors/highstock/highstock',
            //  highchart plugins [START]
            'highstock.data': '../../vendors/highstock/modules/data',
            'highstock.drilldown': '../../vendors/highstock/modules/drilldown',
            'highstock.exporting': '../../vendors/highstock/modules/exporting',
            'highstock.funnel': '../../vendors/highstock/modules/funnel',
            // 'highstock.heatmap': '../../vendors/highstock/modules/heatmap',
            'highstock.no-data-to-display': '../../vendors/highstock/modules/no-data-to-display',
            //  highchart plugins [END]
            //  for SVG => CANVAS [START]
            'stackblur': '../../vendors/stackblur-canvas/dist/stackblur.min',
            'rgbcolor': '../../vendors/rgb-color/rgb-color.min',
            'canvg': '../../vendors/canvg/dist/canvg.min',
            //  for SVG => CANVAS [END]
            'lodash': '../../vendors/lodash/dist/lodash.min',
            'knockout-mapping': '../../vendors/bower-knockout-mapping/build/output/knockout.mapping-latest',
            'kendo-knockout': '../../vendors/knockout-kendo/build/knockout-kendo.min',
            'knockout.validation': '../../vendors/knockout-validation/dist/knockout.validation.min',
            'moment': '../../vendors/moment/min/moment-with-locales.min',
            'numeral': '../../vendors/numeral/numeral',
            'perfect-scrollbar': '../../vendors/perfect-scrollbar/js/min/perfect-scrollbar.jquery.min',
            // pdfmake [START]
            'vfs_fonts': '../__vfs_fonts',
            'pdfmake': '../../vendors/pdfmake/build/pdfmake.min',
            // pdfmake [END]
            // pdf-gear [START]
            'pdfGear': '../../vendors/mojo-babbage-pdf-gear',
            // pdf-gear [END]
            'atn': './atn',
            'viewmodels': './viewmodels',
            'chartApi': './chartApi',
            // 'tests': '../../tests/ut/src/js/app',
            'dataSource': '../dataSource',
            'customPlugins': '../customPlugins',
            'common': '../common',
            'pluginLoader': './pluginLoader',
            'checkPreInit': './checkPreInit',
            'postLogin': './postLogin',
            'es6-promise': '../../vendors/es6-promise/es6-promise',
            'jsZip': '../../vendors/jszip/dist/jszip.min',
            'downloadJs': '../../vendors/downloadJs/download',
            'fileSaver': '../../vendors/file-saver/FileSaver.min'
        },
        shim: {
            'bootstrap': {
                deps: ['jquery']
            },
            'jqueryUi': ['jquery'],
            // 'jqueryCookie': ['jquery'],
            'tTooltip': ['jquery'],
            'highstock': {
                'exports': 'highstock',
                'deps': ['jquery']
            },
            'vfs_fonts': {
                exports: 'vfs_fonts',
                deps: ['pdfmake']
            },
            'pdfmake': {
                exports: 'pdfMake',
            },
            //  highstock plugins [START]
            'highstock.data': ['highstock'],
            'highstock.drilldown': ['highstock'],
            'highstock.exporting': ['highstock'],
            'highstock.funnel': ['highstock'],
            // 'highstock.heatmap': ['highstock'],
            'highstock.no-data-to-display': ['highstock'],
            //  highstock plugins [END]
            //  for SVG => CANVAS [START]
            'canvg': {
                'exports': 'canvg',
                'deps': ['rgbcolor', 'stackblur']
            },
            //  for SVG => CANVAS [END]
            'numeral': {
                'exports': 'numeral',
                'deps': ['jquery']
            },
            // for beautiful scrollbars
            'perfect-scrollbar': ['jquery'],
            'fileSaver': {
                exports: 'saveAs'
            }
        }
    });
}());
define("config", function(){});

